import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { catchError, retry } from 'rxjs/operators';
import { Observable, throwError, of } from 'rxjs';
import { ENV } from 'environments/environment';
import { REQ } from 'environments/common';
import { SessionService } from 'app/components/common/session/session.service';
import { LoginService } from 'app/components/login/login.service';
import { Router } from '@angular/router';
import { CatalogueService } from 'app/components/catalogue/catalogue.service';
import { FiltersService } from 'app/components/filters/filters.service';

@Injectable()
export class InterceptorService implements HttpInterceptor {

  constructor(private sessionService: SessionService, private loginService: LoginService,
    private catalogueService: CatalogueService, private router: Router, private filtersService: FiltersService) {}

  intercept(req, next): Observable<HttpEvent<any>> {

    /** RETURNS MOCKS */
    if (ENV.MOCKS) {

      let mockUrl = this.returnMock(req.url);
      const mockReq = req.clone({ url: mockUrl, params: new HttpParams() });
      return next.handle(mockReq)
        .pipe(
          catchError((error) => this.handleError(error, req.url))
        );

      /** NEEDS AUTH TOKEN */
    } else if (this.shouldAuth(req)) {

      let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

      let user = JSON.parse(this.sessionService.get('username_' + eventData['sapCode'], true));
      let token = JSON.parse(this.sessionService.get('token_' + eventData['sapCode'], true));

      /** Prevent send empty user and token */
      if (!user || !token) {
        return next.handle(req)
          .pipe(
            catchError((error) => this.handleError(error, req.url))
          );
      }

      //Get Auth Token from Service which we want to pass thr service call
      const authToken: any = 'Basic ' + btoa(user + ':' + token);
      const authReq = req.clone({ setHeaders: { 'Authorization': authToken } });

      return next.handle(authReq)
        .pipe(
          catchError((error) => this.handleError(error, req.url))
        );
      /** ELSE */
    } else {
      return next.handle(req)
        .pipe(
          catchError((error) => this.handleError(error, req.url))
        );
    }

  }

  handleError(error, url) {
    console.log('handlError');
    console.log(error);

    let errorMessage = '';

    if (error.status === 401 && url.includes('unifiedSearch')) {
      this.manage401();
      return throwError(error);
    } else {

      if (error.error instanceof ErrorEvent) {
        // A client-side or network error occurred. Handle it accordingly.
        console.error('An error occurred:', error.error.message);
        errorMessage = error.error;
      } else {
        // The backend returned an unsuccessful response code.
        // The response body may contain clues as to what went wrong,
        console.error(
          `Backend returned code ${error.status}, ` +
          `body was: ${error.message}`);
        if (error.error) {
          errorMessage = error.error;
        } else {
          error.message = '';
          errorMessage = error;
        }
      }
      // return an observable with a user-facing error message
      return throwError(errorMessage);
    }

  };

  shouldAuth(req) {
    /** If url is to assets folder return false */
    if ( (req.url.indexOf('/assets/') !== -1) ){
      return false;
    }

    let shouldAuth = true;
    let isInShouldAuthArray = false;

    /** or is in common.ts saffed array return false */
    for( let i = 0; i < REQ.NO_AUTH.length; i++) {
      if (req.url.includes(REQ.NO_AUTH[i])) {

        shouldAuth = false;

        for( let j = 0; j < REQ.SHOULD_AUTH.length; j++){
          if(req.url.includes(REQ.SHOULD_AUTH[j].PARAM)){
            isInShouldAuthArray = true;
          }
        }

      }
    }

    /** If method is post, adds token */
    if (req.method === 'POST' || req.method === 'PUT') {
      shouldAuth = true;
    }

    return shouldAuth || (!shouldAuth && isInShouldAuthArray);

  }

  returnMock(url) {

    if ( (url.indexOf('/assets/') !== -1) ) {
      return url;
    } else {

      /** Get string from /v1 character and replace last slash by _ to make request to json-server */
      let subs = url.split('/v1');
      let index = subs[1].lastIndexOf('/');

      return ENV.MOCKS_BASE_PATH +  subs[1].substr(0, index) + '_' + subs[1].substr(index + 1);

    }

  }

  manage401() {

    this.loginService.removeSessionVariables();

    let url = 'hall-list';
    let queryParams = {};

    if (this.catalogueService.getProperty('eventName')) {
      url = this.catalogueService.getProperty('eventName') + '/home';
      queryParams = { filter: 'ONLY_EXHIBITORS'};

      this.filtersService.setSelectedView('list');
    }

    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([url], { queryParams });
    });

  }

}
